module.exports = __webpack_public_path__ + "img/cs.70aa679c.jpg";